// src/i18n/index.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { DEFAULT_APP_LOCALE, SUPPORTED_APP_LOCALES } from '../lib/locales';

// Import English translations (required)
import en from './locales/en.json';
import af from './locales/af.json';
import zu from './locales/zu.json';
import xh from './locales/xh.json';
import ss from './locales/ss.json';
import tn from './locales/tn.json';
import st from './locales/st.json';
import ts from './locales/ts.json';
import ve from './locales/ve.json';
import nr from './locales/nr.json';
import nso from './locales/nso.json';

const localeModules = { en, af, zu, xh, ss, tn, st, ts, ve, nr, nso };

function isPlainObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value);
}

function deepMergeTranslations(base, overrides) {
  const result = { ...base };

  Object.entries(overrides || {}).forEach(([key, value]) => {
    if (isPlainObject(value) && isPlainObject(base[key])) {
      result[key] = deepMergeTranslations(base[key], value);
      return;
    }

    result[key] = value;
  });

  return result;
}

function loadLocaleFile(locale) {
  const translations = localeModules[locale] || en;
  return locale === DEFAULT_APP_LOCALE ? en : deepMergeTranslations(en, translations);
}

const resources = SUPPORTED_APP_LOCALES.reduce((accumulator, { locale }) => {
  accumulator[locale] = { translation: loadLocaleFile(locale) };
  return accumulator;
}, {});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_APP_LOCALE,
    debug: process.env.NODE_ENV === 'development',
    
    detection: {
      order: ['path', 'localStorage', 'cookie', 'htmlTag', 'navigator', 'subdomain'],
      caches: ['localStorage', 'cookie'],
    },

    interpolation: {
      escapeValue: false,
    },
  })
  .catch((error) => {
    console.error('i18n initialization failed:', error);
  });

export default i18n;
